import { ReactNode } from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';

import Link from 'components/general/Link';
import { articlePath } from 'lib/paths';
import { Article } from 'lib/generated';

interface ArticleItemProps {
  article: Article;
  footer?: ReactNode;
}

const ArticleItem = (props: ArticleItemProps) => {
  const { article, footer } = props;
  return (
    <Box key={article._id} pos="relative" role="group">
      <Link href={articlePath(article.slug)} style={{ textDecoration: 'none' }}>
        <Box
          height="240px"
          position="relative"
          display="flex"
          justifyContent="center"
        >
          <Box
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              backgroundImage: `url('${article.coverPicture}')`,
              backgroundSize: 'cover',
            }}
            _after={{
              boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.15)',
              border: '1px solid rgba(0, 0, 0, 0.15)',
              display: 'block',
              position: 'absolute',
              top: '0px',
              right: '0px',
              bottom: '0px',
              left: '0px',
              content: `''`,
              zIndex: 1,
            }}
          ></Box>
        </Box>
        <Heading size="md">{article.title}</Heading>
        <Text>{article.excerpt}</Text>
        {footer ? footer : null}
      </Link>
    </Box>
  );
};
export default ArticleItem;
